import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import { Autocomplete, TextField } from "@mui/material";
import { forwardRef, useMemo } from "react";
import { MetadataInputProps } from "../metadata-input-index";

interface MetadataInputRatingsProps extends MetadataInputProps {
  cultureId: number | undefined;
}

const MetadataInputRatings = forwardRef<any, MetadataInputRatingsProps>((props, ref) => {
  const { onChange, data, value, cultureId, epNb, titleType } = props;

  const localized = useMemo((): any => {
    return {
      index: (value as any[])?.findIndex((x) => x.system.cultureId === cultureId && x.system.titleType === titleType),
      data: (value as any[])?.find((x) => x.system.cultureId === cultureId && x.system.titleType === titleType)!,
    };
  }, [value, cultureId]);

  return (
    <>
      {localized.index > -1 && (
        <Autocomplete
          id={data.tagName!}
          options={localized.data?.allValues.map((x) => ({ ...x, epNb: epNb ?? null })) ?? []}
          value={localized.data?.values?.find((x) => (x?.epNb ?? null) === (epNb ?? null)) ?? null}
          isOptionEqualToValue={(option: any, value: any) => {
            if (!option || !value) return false;
            return option.code === value.code;
          }}
          onChange={(e, value) =>
            onChange(
              {
                ...localized.data,
                values: localized.data?.values
                  ? [...localized.data.values.filter((x) => (x?.epNb ?? null) !== (epNb ?? null)), value]
                  : [value],
              },
              data.id,
              localized.index
            )
          }
          getOptionLabel={(option) => (option?.description ? `${option?.description} (${option?.code})` : "")}
          multiple={false}
          popupIcon={<ExpandMoreRoundedIcon />}
          renderInput={(params) => <TextField sx={{ mt: "-24px" }} {...params} />}
        />
      )}
    </>
  );
});

export default MetadataInputRatings;
